import angular from "angular";

angular
    .module('app')
    .component('courseExperts', {
        template: require('./course-experts.html'),
        controller: ['$uibModal', 'Notifier', '$http', '$timeout', 'Auth', controller],
        bindings: {
            course: '<',
        }
    });

function controller($uibModal, Notifier, $http, $timeout, Auth) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.getList();
    }

    $ctrl.getList = () => {
        $http
            .get(`/admin/courses/${this.course.id}/get-experts`)
            .then(res => {
                $ctrl.experts = res.data.experts;
            });
    }

    $ctrl.addExpert = () => {
        $uibModal
            .open({
                component: 'expertAttachModal',
                resolve: {
                    course() {
                        return $ctrl.course;
                    }
                },
                size: 'lg'
            })
            .result
            .finally(() => {
                $ctrl.getList();
            });
    };

    $ctrl.delUser = (user) => {
        if (! confirm('Вы действительно хотите удалить со списка данного пользователя?')) {
            return;
        }

        $http
            .post(`/admin/courses/${$ctrl.course.id}/detach-expert`, {
                user_id: user.id
            })
            .finally(() => {
                $ctrl.getList();
            });
    };
}
